/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

function DataTableBodyCell({ noBorder = false, align = "left", children }) {
  const { light } = colors;
  const { borderWidth } = borders;

  return (
    <SoftBox
      component="td"
      textAlign="left"
      fontSize="10px"
      fontWeight={400}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`}
      py={0.75}
      pl={1}
      sx={{
        textTransform: "none",
        "& .MuiTypography-root": {
          fontSize: "10px !important",
          fontWeight: "400 !important",
          textTransform: "none !important",
        },
      }}
    >
      <SoftBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </SoftBox>
    </SoftBox>
  );
}


// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
